import { render, staticRenderFns } from "./stationInfo.vue?vue&type=template&id=d5643580&scoped=true&"
import script from "./stationInfo.vue?vue&type=script&lang=js&"
export * from "./stationInfo.vue?vue&type=script&lang=js&"
import style0 from "./stationInfo.vue?vue&type=style&index=0&id=d5643580&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5643580",
  null
  
)

export default component.exports